<template>
  <div id="admin-system-person">
    <!-- 学员/通讯录 -->
    <diy_table
      :loading="loading"
      :searchData="searchData"
      :buttonList="buttonList"
      :tipData="tipData"
      :active="active"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      :pageData="pageData"
      @showActive="showActive"
      @handleClickTop="handleClickTop"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as personData from "./person.js";
import * as base from "../../js/base.js";
export default {
  data() {
    return {
      userData: {
        // 当前登录用户基本信息
        id: "",
      },
      tipData: [
        { text: "正常", key: "0" },
        { text: "已冻结", key: "1" },
      ],
      loading: true,
      active: "0",
      searchData: this.$systemBaseData.getSearchData("addreddBook"),
      buttonList: this.$systemBaseData.getTopButArray("addreddBook"),
      tableMenu: this.$systemBaseData.getTableMenuData("addreddBook"),
      tableData: [],
      tableButton: this.$systemBaseData.getTableButtonList(
        "addreddBook",
        "normal"
      ),
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 总条目数
      },

      tempQuestion: {},

      optionsList: {
        leverl: [],
        examFlag: [
          { label: "需参加初次到岗考核", value: "0" },
          { label: "需参加复岗考核", value: "1" },
        ],
      },

      dialogData: {
        flag: false,
        title: "通讯录导入",
        width: "40%",
        tempData: {},
        dialogData: [{ type: "import" }],
        buttonList: [
          { text: "确定", active: "makesure_choose_import_type" },
          { text: "取消", active: "cancel" },
        ],
      },

      allAuthorityList: [],
    };
  },
  methods: {
    // 权限设置  获取通讯录设置界面所有子界面的权限  通讯录设置 19
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "19" },
        });
        this.allAuthorityList = resultData;
        this.buttonList = base.returnAllButton(
          this.buttonList,
          resultData,
          "name"
        );
      } catch (error) {}
    },
    /**
     * 获取职业技能鉴定下拉框
     */
    async getStationForSelect() {
      try {
        this.optionsList.leverl = [];
        let reusltData = await this.$request({
          url: "/occupationStation/getStationForSelect",
          method: "post",
          data: { name: "" },
        });
        reusltData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          this.optionsList.leverl.push(dd);
        });
        this.searchData.forEach((element) => {
          if (element.type == "select") {
            element.options = this.optionsList[element.key];
          }
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 初始化表格数据
     */
    initTable(dd) {
      this.loading = true;
      setTimeout(async () => {
        if (this.active == "0") {
          // 正常
          this.tableButton = this.$systemBaseData.getTableButtonList(
            "addreddBook",
            "normal"
          );
        } else {
          this.tableButton = this.$systemBaseData.getTableButtonList(
            "addreddBook",
            "freeze"
          );
        }
        this.tableButton = base.returnAllButton(
          this.tableButton,
          this.allAuthorityList,
          "text"
        );
        let requestData = {
          freeze: this.active == "2" ? "" : this.active,
          pageData: dd.pageData,
        };
        requestData = this.$baseData.array2json(dd.searchData, requestData);
        console.log(requestData);
        try {
          let reusltData = await this.$request({
            url: "/user/getAllUserList",
            method: "post",
            data: requestData,
          });
          reusltData.tableData.forEach((element) => {
            if (element.leverl == "") {
              // 暂无职业技能
              element.leverl = "无";
            }
            if (element.birthday == "") {
              element.birthday = "--";
            }
            if (element.education == "") {
              element.education = "--";
            }
            let rowColor = "#333";
            let hasTip = "";
            if (element.againFlag && element.againFlag != "") {
              // 需要复岗考试
              rowColor = "#ffb03a";
              hasTip = "需参加复岗考核!!!";
            }
            if (element.firstFlag && element.firstFlag != "") {
              // 需要初次到岗考试
              rowColor = "#ff3a3a";
              hasTip = "需参加初次到岗考核!!!";
            }
            this.$set(element, "rowColor", rowColor);
            this.$set(element, "hasTip", hasTip);
          });

          this.pageData.total = reusltData.total;
          this.tableData = reusltData.tableData;
          console.log(this.tableData);
          this.loading = false;
        } catch (error) {
          this.$message.error(error.message);
          this.loading = false;
        }
      }, 500);
    },
    /**
     * 搜索框旁边的按钮操作
     */
    handleClickTop(active) {
      switch (active) {
        case "import":
          // 导入
          this.dialogData.dialogData = [
            {
              type: "import",
              value: {
                type: "9",
                way: "0",
                fileUrl: "", // 已上传的模板路径
                fileName: "", // 已上传的模板名称
                wayOptions: [{ label: "EXCEL 导入", value: "0" }],
              },
            },
          ];
          this.dialogData.title = "通讯录导入";
          this.dialogData.buttonList = [
            { text: "确定", active: "makesure_import" },
            { text: "取消", active: "cancel" },
          ];
          this.dialogData.flag = true;
          break;
        case "create":
          // 新增
          this.$router.push({
            path: "/admin/system-index/edit-person",
            query: {
              id: "",
            },
          });
          break;
        case "export":
          // 导出
          let requestData = {
            freeze: this.active == "2" ? "" : this.active,
          };
          requestData = this.$baseData.array2json(this.searchData, requestData);
          this.$requestForReport(
            "post",
            "/user/exportUser",
            requestData,
            (data) => {
              let blob = new Blob([data], {
                type: "application/force-download",
              }); // Blob 对象表示一个不可变、原始数据的类文件对象
              console.log(blob);
              let fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
              fileReader.readAsDataURL(blob);
              //开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
              fileReader.onload = (e) => {
                let a = document.createElement("a");
                a.download = `人员信息表.xls`;
                a.href = e.target.result;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              };

              this.$message({
                type: "success",
                message: "导出成功!",
                duration: 1000,
              });
            }
          );
          break;

        default:
          break;
      }
    },
    /**
     * 表格中的操作
     */
    async handleClick(data) {
      try {
        this.tempQuestion = JSON.parse(JSON.stringify(data.item));
        let requestData = {
          id: this.tempQuestion.id,
        };
        switch (data.active) {
          case "edit_user":
            //   编辑用户
            console.log("编辑用户", data);
            this.$router.push({
              path: "/admin/system-index/edit-person",
              query: {
                id: this.tempQuestion.id,
              },
            });
            break;
          case "freeze_user":
            //   冻结用户
            if (this.tempQuestion.id == "0" || this.tempQuestion.id == 0) {
              throw { message: "系统超管不可被冻结!!!" };
            }
            this.$confirm(
              "账户冻结后,该用户将不可操作系统的任何功能, 是否继续?",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                try {
                  this.$set(requestData, "freeze", "1");
                  let data = await this.$request({
                    url: "/user/freezeUser",
                    method: "post",
                    data: requestData,
                  });
                  this.$message({
                    type: "success",
                    message: "账号冻结成功!",
                  });
                  await this.initTable({
                    pageData: this.pageData,
                    searchData: this.searchData,
                  });
                } catch (error) {
                  this.$message.error(error.message);
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
            break;

          case "unfreeze_user":
            //   解冻用户
            this.$confirm(
              "若距离冻结时间超3个月,需重新参加复岗考核,是否继续?",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                try {
                  this.$set(requestData, "freeze", "0");
                  let data = await this.$request({
                    url: "/user/freezeUser",
                    method: "post",
                    data: requestData,
                  });
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                  await this.initTable({
                    pageData: this.pageData,
                    searchData: this.searchData,
                  });
                } catch (error) {
                  this.$message.error(error.message);
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
            break;
          case "delete_user":
            //   删除用户
            if (this.tempQuestion.id == "0" || this.tempQuestion.id == 0) {
              throw { message: "系统超管不可被删除!!!" };
            }
            this.$confirm("此操作将永久删除该用户信息, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                try {
                  let data = await this.$request({
                    url: "/user/deleteUser",
                    method: "post",
                    data: requestData,
                  });
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                  await this.initTable({
                    pageData: this.pageData,
                    searchData: this.searchData,
                  });
                } catch (error) {
                  this.$message.error(error.message);
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
            break;
          case "reset_psw":
            // 密码重置
            this.$confirm("密码重置将覆盖其现有密码,是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                try {
                  let data = await this.$request({
                    url: "/user/resetPsw",
                    method: "post",
                    data: requestData,
                  });
                  this.$message({
                    type: "success",
                    message: "密码重置成功!",
                  });
                } catch (error) {}
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 弹出框操作事件
     */
    async dialogOper(active) {
      switch (active) {
        case "makesure_import":
          let requestData = {
            filePath: this.dialogData.dialogData[0].value.fileUrl,
          };
          let resultData = await this.$request({
            url: "/user/importUser",
            method: "post",
            data: requestData,
          });
          if (resultData.flag) {
            this.$message.success("导入成功!");
          } else {
            this.$notify({
              title: "提示",
              dangerouslyUseHTMLString: true,
              message: resultData.errInfo,
              duration: 0,
              type: "error",
            });
          }
          this.dialogData.flag = false;
          await this.initTable({
            pageData: this.pageData,
            searchData: this.searchData,
          });
          break;
        case "cancel":
          this.colseDialog();
          break;

        default:
          break;
      }
    },
    /**
     * active的监听事件
     */
    showActive(data) {
      this.active = data;
    },
    /**
     * 弹出框关闭
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    await this.getUsersAllAuthorityByModel();
    await this.getStationForSelect();
    let data = {
      pageData: this.pageData,
      searchData: this.searchData,
    };
    await this.initTable(data);
  },
};
</script>

<style lang="less" scoped>
#admin-system-person {
  width: 100%;
  height: 100%;
}
</style>